import { TemplateFilter } from 'dashboard/lib/workflows/objects';
import { WorkflowModule } from 'dashboard/models/workflow-module';
import { WorkflowSchema as _WorkflowSchema } from 'dashboard/models/workflow-schema';
import { WorkflowStep } from 'dashboard/models/workflow-version';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum WorkflowBlockStatus {
  Draft = 'draft',
  Published = 'published',
  Archived = 'archived',
}

export type BlockInput = {
  token: string;
  name: string;
  schema: string;
  required: boolean;
};

export type BlockOutput = {
  token: string;
  name: string;
  'method-chain': string;
};

export interface WorkflowBlockAttributes {
  status: WorkflowBlockStatus;
  'steps-config': WorkflowStep[];
  'created-at': string;
  'updated-at': string;
  'edited-at': string;
  'published-at': string;
  description: string;
  inputs: BlockInput[];
  outputs: BlockOutput[];
  'last-updater': string;
  'template-filters': TemplateFilter[];
}

export type BlockParent = WorkflowModule;
export interface WorkflowBlockRelationships {
  parent: ApiRelationship<BlockParent['type']>;
}

export type WorkflowBlock = ApiResource<
  WorkflowBlockAttributes,
  WorkflowBlockRelationships,
  ApiModel.WorkflowBlock
>;
